
import {Component, Prop, Vue} from "vue-property-decorator";
import dataFieldTypesReadonly from "@/dataFieldReadonlyTypes";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'FieldGroupReadonly',
  components: {
    ...dataFieldTypesReadonly,
  },
})
export default class FieldGroupReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  get isVisible() {
    return this.dataField?.isVisible ?? false;
  }

  get displayName() {
    return this.dataField?.displayName;
  }

  get childFields() {
    return this.dataField?.childFields ?? [];
  }

}
